import {getToken, saveLoginInfo} from '@/utils/auth'
import {getInfo} from "@/api/login.js";
import {getInfo as getInfoH5} from "@/api/h5/login";

const useUserStore = defineStore(
    'user',
    {
        state: () => ({
            token: getToken(),
            userInfo: {},
        }),
        actions: {
            // 获取用户信息
            getInfo() {
                return new Promise((resolve, reject) => {
                    let api = getInfo
                    if (location.href.indexOf('/h5') > -1) {
                        api = getInfoH5
                    }
                    api().then(res => {
                        this.userInfo = res.user || {}
                        saveLoginInfo(res.user,this.token)
                        resolve(res)
                    }).catch(error => {
                        reject(error)
                    })
                })
            },
            setToken(token){
                this.token = token;
            }
        },
      /*  persist:{
            key:'user',
            // pick:['userInfo']
        }*/
    },

)

export default useUserStore
